// extracted by mini-css-extract-plugin
module.exports = {"light":"Wrapper_light__1EeQN","card":"Wrapper_card__3xm43","loaderBlock":"Wrapper_loaderBlock__6t01B","noData":"Wrapper_noData__1D0A2","sourceList":"Wrapper_sourceList__33IGS"};